export const FamilyRol = [
    {
        id: 1,
        name: "Padre",
        value: "P",
    }, {
        id: 2,
        name: "Madre",
        value: "M"
    }, {
        id: 3,
        name: "Edudiante",
        value: "H"
    }
]

export const GenderPerson = [{
    id: 1,
    name: "Masculino", 
    value : "M"
}, {
    id: 2,
    name: "Femenino",
    value: "F"
}]

export const rolesSystem:any = {
    'admin' : "Super Admin",
    'card-generator': "Generador de Carnet",
    'attendance-recorder': "Registrador de Asistencia",
    'holiday': "Configuracion de Dias L/F",
    'schedule' : "Horario Adicional",
    'report': "Reportes Globales y Adicionales",
    'students': "Acceso a listado de estudiantes",
    'families': "Accesos a listado de familias",
    'report-student': "Acceso a reporte de asistencia de estudiantes"
}